export enum TypeOfDay {
  WORKDAY = 'P',
  PUBLIC_HOLIDAY = 'UDW',
  REST_DAY = 'DW'
}
